<div class="donor-container">
  <ng-container [ngSwitch]="model.type">
    <div class="attendee-type" *ngSwitchCase="'sold'">
      <app-icon-sold></app-icon-sold>
    </div>

    <div class="attendee-type" *ngSwitchCase="5">
      <app-icon-silent-auction-closed [color]="type === 'dark' ? '#FFFFFF': '#000000'" ></app-icon-silent-auction-closed>
    </div>

    <div class="attendee-type" *ngSwitchCase="2">
      <app-icon-winner-declared></app-icon-winner-declared>
    </div>

    <ng-container *ngSwitchDefault>
      <ng-container *ngIf="model.attendeeType === 0; else inPersonIcon">
        <div class="attendee-type">
          <app-icon-virtual></app-icon-virtual>
        </div>
      </ng-container>

      <ng-template #inPersonIcon>
        <div class="attendee-type">
          <app-icon-in-person></app-icon-in-person>
          <div *ngIf="model.inPersonPaddleNum" class="in-person-paddle-number"> {{ '#' + model.inPersonPaddleNum }}</div>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>

  <div class="price">
    <ng-container [ngSwitch]="model.type">
      <div class="activity-type amount text-truncate" *ngSwitchCase="'pledge'">
        Pledge of {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}
      </div>
      <div class="activity-type amount text-truncate" style="color: #25C157" *ngSwitchCase="'sold'">
        Sold for {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}
      </div>
      <div class="activity-type amount text-truncate" *ngSwitchCase="1">
        Bid of {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}
      </div>
      <div class="activity-type amount text-truncate" *ngSwitchCase="6">
        Sell More of {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}
      </div>
      <div class="activity-type amount text-truncate" *ngSwitchCase="'recurring'">
        Recurring {{ model.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}
      </div>

      <div class="activity-type amount text-truncate" [ngStyle]="{'color': type === 'dark' ? '#F9CE23': '#000000'}"  *ngSwitchCase="2">
        Winner Declared
      </div>

      <div class="activity-type amount text-truncate" *ngSwitchCase="3">
        Last Hero Declared
      </div>

      <div class="activity-type amount text-truncate" *ngSwitchCase="4">
        Live Item changed
      </div>

      <div class="activity-type amount text-truncate" *ngSwitchCase="5">
        Silent Auction closed
      </div>
    </ng-container>
  </div>
  <span class="username"> {{ model.data.name }} </span>
  <div class="sent">
    <div>{{ model.timer$ | async | activityTimer:index }}</div>
  </div>
</div>
